module.exports = __webpack_public_path__ + "img/panierbleu_htal_vignette_faisonsrouler_rgb.e10d76b6.svg";